import { CircleX, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CreateErrorToastProps } from "./types";

export default function CreateErrorToast({
  errorMsg,
  onClose,
  onRetry,
}: CreateErrorToastProps) {
  if (!errorMsg) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-slide-up"
    >
      <div className="alert-error rounded-2xl px-4 py-4 shadow-2xl flex items-start gap-3 backdrop-blur-sm">
        {/* Error Icon */}
        <div className="flex-shrink-0 mt-0.5">
          <CircleX className="w-6 h-6" aria-hidden />
        </div>

        {/* Message */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium leading-relaxed break-words">
            {errorMsg}
          </p>
          {onRetry && (
            <p className="text-xs text-muted-foreground mt-1">
              Click Try again when you&apos;re ready.
            </p>
          )}
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-1.5 flex-shrink-0">
          {onRetry && (
            <Button
              onClick={onRetry}
              variant="outline"
              size="sm"
              className="hover:opacity-90 transition-opacity"
              aria-label="Try again"
            >
              Try again
            </Button>
          )}
          <Button
            onClick={onClose}
            variant="ghost"
            size="sm"
            className="-mr-1 -mt-1 hover:opacity-70 transition-opacity p-1.5 rounded-lg"
            aria-label="Close error message"
          >
            <X className="w-5 h-5" aria-hidden />
          </Button>
        </div>
      </div>
    </div>
  );
}
